export default __webpack_public_path__ + "static/assets/eb0c73cb0eedc8fc0c8acbb62229382d.png";